import React from 'react';
import styled, { css } from 'styled-components';

import Tune from '@/components/atom/icon/Tune';
import HospitalFilter from '@/components/templates/f2f/common/hospital-filter';
import theme from '@/styles/theme';

interface EntireProps {
  count: number;
  onClick: () => void;
}

const HospitalSearchFilters = ({ children }: React.PropsWithChildren) => {
  return <Wrapper>{children}</Wrapper>;
};

const EntireFilter = ({ count, onClick }: EntireProps) => {
  return (
    <EntireFilterWrapper onClick={onClick}>
      <EntireFilterButton count={count}>
        <Tune fill={count > 0 ? theme.color.primary600 : theme.color.black} />
      </EntireFilterButton>
    </EntireFilterWrapper>
  );
};

const ScrollFilters = ({ children }: React.PropsWithChildren) => {
  return <ScrollWrapper>{children}</ScrollWrapper>;
};

export default HospitalSearchFilters;

HospitalSearchFilters.EntireFilter = EntireFilter;
HospitalSearchFilters.ScrollFilters = ScrollFilters;
HospitalSearchFilters.HospitalFilter = HospitalFilter;

const Wrapper = styled.div`
  position: sticky;
  display: flex;
  overflow: hidden;
  padding: 12px 0 12px 24px;
  z-index: 10;
  background-color: ${({ theme }) => theme.color.white};
  top: ${({ theme }) => {
    const { client } = theme;
    if (client.isWebView) {
      return '60px';
    }
    if (client.isMobile) {
      return '120px';
    }
    return '60px';
  }};
`;

const ScrollWrapper = styled.div`
  display: flex;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  gap: 8px;
  padding-left: 12px;
  padding-right: 24px;
`;

const EntireFilterWrapper = styled.div`
  padding-right: 12px;
  border-right: 1px solid ${({ theme }) => theme.color.gray100};
`;

const EntireFilterButton = styled.button<{ count: number }>`
  position: relative;
  width: 36px;
  height: 36px;
  ${({ theme, count }) => css`
    border: 1px solid
      ${count > 0 ? theme.color.primary600 : theme.color.gray100};
    background-color: ${count > 0 ? theme.color.primary100 : theme.color.white};
    border-radius: 50%;
    &::after {
      ${theme.typography.UI10R}
      color: ${theme.color.white};
      display: ${count > 0 ? 'flex' : 'none'};
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(0, -3.5px);
      content: '${count}';
      width: 14px;
      height: 14px;
      background-color: ${theme.color.red900};
      border-radius: 50%;
    }
  `}
`;
